import {Chip, makeStyles, TextField} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from "@material-ui/core/InputLabel";
import React, {useCallback, useEffect, useState} from "react";
import CircularProgress from "@mui/material/CircularProgress";
import styled from "styled-components";
import {Colors} from "../../theme/colors";


const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: '0 !important',
		maxWidth: '100%',
		'& > * + *': {
			marginTop: theme.spacing(3),
		},
	},
	label: {
		color: '#758089 !important',
		fontSize: '0.9rem',
		fontWeight: 400,
		position: 'relative',
		lineHeight: '144%',
		transition: 'none',
		transform: 'none',
		marginBottom: '5px'
	}
}));

export const AutocompleteSelectApi: React.FC<Props> = (
	{values, fieldName, label, error, setFieldValue, getOptionLabel, loadData, multiple, searchInputPlaceholder}
) => {
	const [options, setOptions] = useState<any[]>([]);
	const [loading, setLoading] = useState(false);
	const classes = useStyles();

	const loadOptions = useCallback(async (search: string, page: number, perPage: number) => {
		setLoading(true);
		const res = await loadData(search, page, perPage);
		setOptions(res);
		setLoading(false);
	}, [loadData])

	useEffect(() => {
		loadOptions('', 1, 30);
	}, [loadOptions]);

	const onInputChange = (event, value, reason) => {
		loadOptions(value, 1, 30);
	};

	return (
		<div className={classes.root}>
			<StyledAutocomplete
				multiple={multiple}
				id={fieldName}
				options={options}
				getOptionLabel={getOptionLabel}
				value={values[fieldName]}
				loading={loading}
				onInputChange={onInputChange}
				onChange={(e, value) => {
					setFieldValue(fieldName, value);
				}}
				renderInput={(params) => {
					// @ts-ignore
					return <div ref={params.InputProps.ref}>
						<InputLabel shrink htmlFor={fieldName} className={classes.label}>
							{label}
						</InputLabel>
						<TextField
							{...params}
							variant="outlined"
							placeholder={searchInputPlaceholder}
							error={error}
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<React.Fragment>
										{loading ? <CircularProgress color="inherit" size={20} /> : null}
										{params.InputProps.endAdornment}
									</React.Fragment>
								),
							}}
						/>
					</div>
				}}
			/>
		</div>
	);
}

interface Props {
	values: any,
	fieldName: string,
	label: string,
	error: boolean,
	setFieldValue: any,
	getOptionLabel: (option) => string,
	loadData: (search: string, page: number, perPage: number) => Promise<any[]>,
	multiple: boolean,
	searchInputPlaceholder: string
}

const StyledAutocomplete = styled(Autocomplete)`

  .MuiOutlinedInput-root {
    border-radius: 12px;
    background-color: #fff;

    fieldset {
      border-color: ${Colors.neutral90};
    }

    &:hover {
      fieldset {
        box-shadow: 0 0 0 4px ${Colors.warning95};
        border-color: ${Colors.primary70};
      }
    }

    &.Mui-focused {
      fieldset {
        border: 1px solid ${Colors.primary70};
      }
    }

    &.Mui-error {
      fieldset {
        border-color: ${Colors.error20};
      }

      &:hover {
        fieldset {
          box-shadow: 0 0 0 4px #F2B8B5;
        }
      }
    }
  }
`;
